import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Nav.css";
import logo from "../../assets/logo.png";
import { 
	// useDispatch,
	useSelector
} from "react-redux";
import { selectUser } from "../../features/userSlice";

function Nav() {
	const [show, handleShow] = useState(false);
	const history = useNavigate();
	const user = useSelector(selectUser);


	const transitionNavBar = () => {
		if (window.scrollY > 100) {
			handleShow(true);
		} else handleShow(false);
	};

	useEffect(() => {
		window.addEventListener("scroll", transitionNavBar);
		return () => {
			window.removeEventListener("scroll", transitionNavBar);
		};
	}, []);

	return (
		<div className={`nav ${show && "nav__black"}`}>
			<div className="nav__contents">
				<div className="mainMenu">
					<img
						onClick={() => history("/")}
						className="nav__logo"
						src={logo}
						alt="Netflix Logo"
					/>
					<nav>
						<Link to={"/"}>Home</Link>
						<Link to={"/"}>Movies</Link>
						<Link to={"/"}>TV Shows</Link>
						<Link to={"/"}>New & Popular</Link>
					</nav>
				</div>
				{!user ? (
					<button
						className="login_button"
						onClick={() => history("/landing")}
					>
						Sign in
					</button>
				) :(
					<img
						onClick={() => history("/profile")}
						className="nav__avatar"
						src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png?20201013161117"
						alt="Netflix Avatar"
					/>
				)}

			</div>
		</div>
	);
}

export default Nav;
